import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Typography, Button, Paper } from '@mui/material';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import HomeIcon from '@mui/icons-material/Home';

export default function ErrorPage() {
    const navigate = useNavigate();

    return (
        <Container
            maxWidth="sm"
            sx={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    p: { xs: 5, sm: 8 },
                }}
            >
                <Box
                    sx={{
                        width: 88,
                        height: 88,
                        borderRadius: '50%',
                        bgcolor: '#FEF2F2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 4,
                    }}
                >
                    <SentimentDissatisfiedIcon sx={{ fontSize: 44, color: '#EF4444' }} />
                </Box>

                <Typography
                    variant="h1"
                    sx={{
                        fontWeight: 800,
                        fontSize: { xs: '4rem', sm: '5rem' },
                        color: 'primary.main',
                        lineHeight: 1,
                        mb: 2,
                        letterSpacing: '-0.04em',
                    }}
                >
                    404
                </Typography>

                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 600,
                        color: 'text.primary',
                        mb: 1.5,
                    }}
                >
                    Page not found
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        color: 'text.secondary',
                        mb: 5,
                        maxWidth: 360,
                        lineHeight: 1.7,
                    }}
                >
                    The page you're looking for doesn't exist or has been moved. Let's get you back on track.
                </Typography>

                <Button
                    variant="contained"
                    size="large"
                    disableElevation
                    startIcon={<HomeIcon />}
                    onClick={() => navigate('/')}
                    sx={{
                        px: 4,
                        py: 1.5,
                        fontWeight: 600,
                        fontSize: '1rem',
                    }}
                >
                    Go Home
                </Button>
            </Paper>
        </Container>
    );
}
